import { useMemo } from 'react';
import {
  computeMotivational,
  type MotivationalData,
} from '../utils/motivational-calculations';
import { useCollectorCreators } from './use-collector-creators';
import { useLeaderboard } from './use-leaderboard';

export function useMotivationalStats(collectorId: string | undefined): {
  data: MotivationalData | undefined;
  isLoading: boolean;
} {
  const { data: creators, isLoading } = useCollectorCreators(collectorId);
  const { data: leaderboard } = useLeaderboard('week');

  const data = useMemo((): MotivationalData | undefined => {
    if (!creators || !leaderboard || !collectorId) return undefined;
    return computeMotivational(creators, leaderboard, collectorId);
  }, [creators, leaderboard, collectorId]);

  return { data, isLoading };
}
